import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=947856ba&scoped=true"
import script from "./BaseSection.vue?vue&type=script&lang=js"
export * from "./BaseSection.vue?vue&type=script&lang=js"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=947856ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947856ba",
  null
  
)

export default component.exports